import i18n from '@nextroll/ar-i18n';

import { TriggerRuleTypeOption, TRIGGER_RULE_TYPES } from './ContactTriggerNode.type';

export const CONTACT_TRIGGER_WARNING = {
    OUT_OF_SYNC: i18n.gettext('The selected list is out of sync due to some issues. You can fix it in Contact List.'),
};

export const CONTACT_TRIGGER_ERROR = {
    BASIC: i18n.gettext('Unable to access your Contact Lists at the moment. Please exit the workflow builder and try again.'),
    NO_DATA: i18n.gettext('You have not created a contact list that is supported in Workflows. Please start with creating a Contact List.'),
    DELETED: i18n.gettext('The selected list has been deleted. Please select another list.'),
    // need to review error messages..
    UNSELECTED_TYPE: i18n.gettext('Required to select a trigger type.'),
};

export const TRIGGER_RULE_TYPE_OPTIONS = [
    {
        type: TRIGGER_RULE_TYPES.CUSTOM,
        label: i18n.gettext('Custom Criteria'),
        tooltip: i18n.gettext('Define a custom set of rules to trigger the workflow')
    },
    {
        type: TRIGGER_RULE_TYPES.LIST_MEMBERSHIP,
        label: i18n.gettext('List Membership'),
        tooltip: i18n.gettext('Trigger the workflow when a Contact meets the criteria of a Contact List')
    },
] as TriggerRuleTypeOption[];
